import type { 
  Column
} from 'react-data-grid'

interface ProductItem {
  id: string;
  brand: string;
  brandType: string;
  materialCode: string;
  barcode: string;
  name: string;
  titleEN: string;
  titleTH: string;
  category: string;
  subcategory: string;
  collection: string;
  color: string;
  classifier: string;
  status: string;
  length: number;
  width: number;
  height: number;
  weight: number;
  weightUnit: number;
  description: string;
  images: any;
  tags: any;
}

export const NotExistProductColumn: Column<ProductItem>[] = [
  { key: 'material_code', name: 'material_code', width: 120 },
  { key: 'material_name', name: 'material_name' },
  { key: 'barcode_ea', name: 'barcode_ea' },
  { key: 'barcode_pac', name: 'barcode_pac' },
  { key: 'barcode_cs', name: 'barcode_cs' },
]
